import { OnboardingThread } from '../assistant/OnboardingThread'

/**
 * What a new user sees, and what someone sees after deleting everything.
 *
 * Everything else on the screen — the balance chart, shortfalls, reconciliation — is an
 * answer to a question that cannot be asked yet. Showing empty versions of all of them
 * would be worse than showing none: an empty chart implies a flat balance rather than no
 * data, and "every account stays above zero" is vacuously true and actively misleading
 * when there are no accounts.
 *
 * Setup is a conversation now. The separate buttons this used to carry are gone because
 * the flow does everything they did and does it in one place — two routes to the same
 * outcome, sitting next to each other, only made the screen ask the user to choose an
 * interface before choosing an account.
 */
export function GettingStarted() {
  return (
    <section className="onboarding">
      <OnboardingThread />
    </section>
  )
}
